import { authAxios } from "./../../config/axios";

class Membership {
  get = (params = []) => {
    return authAxios.get(`/plan/memberships`, {
      params,
    });
  };

  show = (id) => {
    return authAxios.get(`/plan/memberships/${id}`);
  };

  update = (id, data) => {
    return authAxios.put(`/plan/memberships/${id}`, data);
  };

  save = (data) => {
    let formData = new FormData();

    for (let k in data) formData.append(k, data[k]);

    return authAxios.post(`/plan/memberships/save`, formData);
  };

  updateImage = (id, image) => {
    let formData = new FormData();
    formData.append("image", image);
    return authAxios.post(`/plan/memberships/${id}/image`, formData);
  };
}

export default new Membership();
